import React from 'react';
import DashEstablishmentContainer from 'modules/dashboard/_common/DashEstablishmentContainer';
import CustomersPage from 'modules/dashboard/restaurant/customers/CustomersPage';

export default function DashRestaurantCustomers() {
    return (
        <DashEstablishmentContainer title='Clientes'>
            <CustomersPage />
        </DashEstablishmentContainer>
    );
}
